import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-[var(--color-ring)] focus-visible:ring-[var(--color-ring)]/50 focus-visible:ring-[3px] aria-invalid:ring-[var(--color-destructive)]/20 dark:aria-invalid:ring-[var(--color-destructive)]/40 aria-invalid:border-(--color-destructive)",
  {
    variants: {
      variant: {
        default:
          "[background-color:var(--color-primary)] text-white [color:var(--neutral-50)] border border-(--color-primary)  hover:[background-color:var(--color-accent)] hover:border-[var(--color-accent)]",
       destructive:
          "[background-color:var(--color-destructive)] [color:var(--neutral-50)] hover:[background-color:var(--color-accent)]/90 focus-visible:ring-(--color-destructive)/20 dark:focus-visible:ring-(--color-destructive)/40",
        outline:
          "border-2 border-(--color-primary) text-(--color-primary) hover:border-[var(--color-accent)] hover:text-(--color-accent)",
        secondary:
          "[background-color:var(--color-secondary)] [color:var(--neutral-50)] hover:[background-color:var(--color-secondary)]/80",
        ghost:
          "hover:[background-color:var(--neutral-100)] hover:[color:var(--color-accent)]",
        link: 
          "[color:var(--color-primary)] underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2 has-[>svg]:px-3",
        sm: "h-8 rounded-sm gap-1.5 px-3 has-[>svg]:px-2.5",
        lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
        icon: "size-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

function Button({
  className,
  variant,
  size,
  asChild = false,
  ...props
}) {
  const Comp = asChild ? Slot : "button"

  return (
    <Comp
      data-slot="button"
      className={cn(buttonVariants({ variant, size, className }))}
      {...props} />
  );
}

export { Button, buttonVariants }
